import { useCallback } from 'react';
import { useStore } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { logChatbotClickOnSolution, SolutionTypes } from '../../bi';
import { appRoutes } from '../../routes';

type OpenArticleFromChatbot = (articleId: string) => void;

export const useOpenArticleFromChatbot = (): OpenArticleFromChatbot => {
  const store = useStore();
  const navigate = useNavigate();

  return useCallback(
    (articleId) => {
      const pathname = appRoutes.articleById({ articleId });
      const state = store.getState();

      logChatbotClickOnSolution(state, {
        solutionId: articleId,
        solutionType: SolutionTypes.ARTICLE,
      });

      navigate(pathname);
    },
    [store, navigate],
  );
};
